import { todoApi } from './todoApi';
import { paymentsApi } from './paymentsApi';

// Export the real API only
export const api = todoApi;
export { todoApi as realApi };
export { paymentsApi };
